import React from "react";
//#region types
import { ViewPanelTitleProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ViewPanelTitle: React.FC<ViewPanelTitleProps> = (props) => {
  const isMultiLine = props.description ? true : false;

  return (
    <Grid item container direction="column" className={cssExports.viewPanelTitleOuterContainer}>
      <Grid
        item
        container
        alignItems={isMultiLine ? "flex-start" : "center"}
        className={cssExports.viewPanelTitleContainer}
      >
        {props.icon && (
          <Grid item className={cssExports.viewPanelIcon}>
            <Icon icon={props.icon} />
          </Grid>
        )}
        <Grid item container xs gap={0.5} direction="column" className={cssExports.viewPanelTitleInnerContainer}>
          <Grid item xs className={cssExports.viewPanelTitle}>
            {props.title}
          </Grid>
          {isMultiLine ? (
            <Grid item xs className={cssExports.viewPanelDescription}>
              {props.description}
            </Grid>
          ) : null}
        </Grid>
        {props.topRightContent}
      </Grid>
      {props.additionalContent && (
        <Grid item className={cssExports.viewPanelAdditionalContent}>
          {props.additionalContent}
        </Grid>
      )}
    </Grid>
  );
};

export default ViewPanelTitle;
